import React from "react";

const LiveBlogCard = ({ constituencyDetailData }) => {
  console.log("constituencyDetailData", constituencyDetailData?.post_live_blog);

  return (
    <div className=" mx-2 mb-4 bg-white   shadow-md rounded-md overflow-hidden border border-gray-200  ">
      {/* Header */}
      <div className="  py-3 border-b border-gray-200    bg-[#F1F2FA] flex items-center">
        <span className="w-7 h-7   rounded-full ml-2 mr-1">
          {" "}
          <img src="https://akm-img-a-in.tosshub.com/lingo/newstak/resources/prod/liveIcon.gif" />
        </span>
        <h2 className="text-[#CF4C9B] font-semibold text-[15px]">
          {constituencyDetailData?.title}
        </h2>
      </div>

      {/* Main Highlight */}
      <div className="px-4 py-3 ">
        <h3 className="font-semibold text-[15px] text-gray-800   leading-relaxed">
          {constituencyDetailData?.post_live_blog?.[0]?.title}
        </h3>
      </div>
      <hr />
      {/* Updates List */}
      <div className="divide-y divide-gray-200">
        {constituencyDetailData?.post_live_blog
          ?.map((item, i) => (
            <div key={i} className="px-4 py-3">
              {/* Time + Dot + Date */}
              <div className="flex items-center gap-2 text-xs text-gray-500 mb-1">
                <span className="w-2 h-2 bg-[#CF4C9B] rounded-full inline-block"></span>
                {/* <p className="text-sm text-gray-800">{item.title}</p> */}
                <div className="flex items-center gap-2 text-gray-600 text-sm">
                  <span className="font-medium">
                    {new Date(item?.datetime_updated)?.toLocaleTimeString(
                      "en-US",
                      { hour: "2-digit", minute: "2-digit" }
                    )}
                  </span>
                  <span className="w-1 h-1 bg-[#CF4C9B] rounded-full inline-block"></span>
                  <span>
                    {new Date(item?.datetime_updated)?.toLocaleDateString(
                      "en-US",
                      { year: "numeric", month: "short", day: "numeric" }
                    )}
                  </span>
                </div>


              </div>
              <p className="text-sm mx-4 text-gray-800">{item?.title}</p>
              {/* News Text */}
              {/* <p
                className="text-sm mx-4 text-gray-800"
                dangerouslySetInnerHTML={{  __html: item?.description.replace(/<input[^>]*type=["']?checkbox["']?[^>]*>/gi, "") }}
              ></p> */}
            </div>
          ))
          ?.slice(1, 4)}
      </div>

      {/* Load More Button */}
      <div className="p-4 text-center">
        <a
          href={constituencyDetailData?.canonical_url}
          className="block w-full bg-[#CF4C9B] hover:bg-[#d83f9b] text-white py-2 rounded-md text-sm font-semibold text-center"
        >
          और पढ़ें
        </a>
      </div>
    </div>
  );
};

export default LiveBlogCard;
